import { Document } from '@/utils/types/document'

const getStatusColor = (status: Document['status']) => {
  switch (status) {
    case 'draft':
      return 'grey'
    case 'active':
      return 'success'
    case 'in_progress':
      return 'success'
    case 'archived':
      return 'warning'
    case 'on_registration':
      return 'info'
    case 'registration_cancelled':
      return 'error'
    case 'under_review':
      return 'warning'
    case 'in_execution':
      return 'success'
    default:
      return 'grey'
  }
}

export { getStatusColor }
